import { axios } from '@Root/API'

export const edit = (studyProgrammeId, supervisorAllocationId, payload) => {
	return axios.post(`course-session/${studyProgrammeId}/supervisor-allocation/${supervisorAllocationId}`, payload)
}
